const ROUTES = {
  home: "/",
  login: "/login",
  adminLogin: "/admin-login",
  dispatchLogin: "/dispatch-login",
  setPassword: "/set-password",
  residencyInfo: "/residency-info",
  phoneVerification: "/phone-verification",
  ambulanceRequest: "/ambulance-requests",
  ambulanceProviders: "/ambulance-providers",
  cases: "/cases",
  users: "/users",
  map: "/map",
  updateCase: "/cases/update/:case_id",
  hospitals: "/hospitals",
  inquiries: "/inquiries",
  signUp: "/sign-up",
  responders: "/responders",
  createResponder: "/responders/create",
  forgotPassword: "/forgot-password",
  changePassword: "/forgotPassword/change_password",
  profile: "/settings",
  notFound: "*",
};

export default ROUTES;
